import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useCmdAuth } from "../contexts/CmdAuthContext";

export default function CmdFounderSetup() {
  const { me, setupNeeded, setupFounder } = useCmdAuth();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  if (setupNeeded === false) return <Navigate to="/cmd/login" replace />;
  if (me) return <Navigate to="/cmd" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (password.length < 8) { setErr("Password must be at least 8 characters."); return; }
    if (password !== confirm) { setErr("Passwords do not match."); return; }
    setBusy(true);
    try {
      await setupFounder(name.trim(), email.trim(), password);
      navigate("/cmd", { replace: true });
    } catch (ex) {
      setErr(ex?.response?.data?.detail || "Setup failed. Try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="cmd-root">
      <div className="cmd-auth-wrap">
        <form className="cmd-auth-card" onSubmit={submit} data-testid="cmd-setup-form">
          <h1>Create the founder account</h1>
          <p className="sub">This happens once. You will be the Founder of EEPL Command Room.</p>

          <div className="cmd-field">
            <label htmlFor="cmd-setup-name">Full name</label>
            <input id="cmd-setup-name" className="cmd-input" value={name}
              onChange={(e) => setName(e.target.value)} required data-testid="cmd-setup-name" />
          </div>
          <div className="cmd-field">
            <label htmlFor="cmd-setup-email">Email</label>
            <input id="cmd-setup-email" type="email" className="cmd-input" value={email}
              onChange={(e) => setEmail(e.target.value)} required data-testid="cmd-setup-email" />
          </div>
          <div className="cmd-field">
            <label htmlFor="cmd-setup-password">Password</label>
            <input id="cmd-setup-password" type="password" className="cmd-input" value={password}
              onChange={(e) => setPassword(e.target.value)} required minLength={8}
              data-testid="cmd-setup-password" />
          </div>
          <div className="cmd-field">
            <label htmlFor="cmd-setup-confirm">Confirm password</label>
            <input id="cmd-setup-confirm" type="password" className="cmd-input" value={confirm}
              onChange={(e) => setConfirm(e.target.value)} required minLength={8}
              data-testid="cmd-setup-confirm" />
          </div>
          {err && <div className="cmd-error" data-testid="cmd-setup-error">{err}</div>}
          <button className="cmd-btn cmd-btn-primary" type="submit" disabled={busy}
            style={{ width: "100%", marginTop: 8 }} data-testid="cmd-setup-submit">
            {busy ? "Creating…" : "Create founder account"}
          </button>
        </form>
      </div>
    </div>
  );
}
